export  class Country{
    id: number;
    name: string;
    alpha2: string;
    alpha3: string
}